export default __webpack_public_path__ + "static/logo-neg-1efb04f98c8bf8f495da5b88e5bfd328.ico";